<template>
  <div class="flex items-center py-8">
    <div class="my-auto flex w-full flex-col items-center px-8 sm:flex-row">
      <div
        class="mt-4 cursor-pointer text-xl font-bold uppercase tracking-wide sm:mt-0"
        @click="$router.push('/')"
      >
        <span class="text-red-300">Tic</span>
        <span class="text-blue-300">Tac</span>
        <span class="text-green-300">Toe</span>
        <span class="text-yellow-300">2</span>
      </div>
      <div class="ml-auto mr-auto mt-6 sm:ml-auto sm:mr-0 sm:mt-0">
        <div
          class="flex items-center"
          :class="{
            'pointer-events-none opacity-30': $store.state.game.isGameActive,
          }"
        >
          <div class="mr-2 text-xs uppercase tracking-wider text-white">
            Your name
          </div>
          <input
            class="rounded px-1 py-1 text-sm"
            type="text"
            v-model="username"
            @change="setUsernameCookie"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: this.getUsernameCookie(),
    };
  },

  methods: {
    getUsernameCookie() {
      const username = window.localStorage.getItem('username');
      if (username) {
        return username;
      }

      return 'Anonymous';
    },

    setUsernameCookie() {
      window.localStorage.setItem(
        'username',
        this.username ? this.username : 'Anonymous'
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UserBar.vue